import { Long, util } from "protobufjs";
import AppData from "../pacakge/public/const/app_data";
import MemoryStorage from "../manager/memory_storage";
import ModelData from '../pacakge/public/model_data';
import ModuleManager from '../framework/core/module_manager';
import AppController from "../sdk/app_controller";
import * as CryptoJS from 'crypto-js';
import { resLoader } from "../framework/res/ResLoader";
import Utility from './utility';
import LoaclStorage from "../manager/local_storage";
import LogManager from "../manager/log_manager";



export default class GameUtil {

    static _systemInfo = null//系统信息

    static unit = ['', 'K', 'M', 'B', 'T'];

    static _systemOS = "Android"

    static init() {
        if (CC_JSB) {
            this._systemOS = cc.sys.os === cc.sys.OS_ANDROID ? "Android" : "iOS"
        }
    }

    static apiHttpGet(requestData: IHttpRequestData, responeSuccessCallback: (data : IHttpApiResponeData) => void, requestErrorCallback?: (error: IHttpErrorData) => void) {
        if (!requestData.hasOwnProperty("isApiRequest")) {
            requestData.isApiRequest = true
        }
        if (!requestData.hasOwnProperty("params")) {
            requestData["params"] = {}
        }
        if (!requestData.params.hasOwnProperty("gameUserId")) {
            requestData.params["gameUserId"] = ModelData.instance.roleData.id
        }
        GameUtil.http_get(requestData, responeSuccessCallback, requestErrorCallback)
    }

    static http_get(requestData: IHttpRequestData, responeSuccessCallback: (data: any) => void, requestErrorCallback?: (error: IHttpErrorData) => void) {
        if (requestData.params) {
            if (requestData.useCache) {
                requestData.cacheKey = requestData.cacheKey ? requestData.cacheKey : GameUtil.formatParamsForHttp(requestData)
                cc.log("=======", requestData.cacheKey)
                let response = LoaclStorage.getJson(requestData.cacheKey)
                if (response) {
                    if (AppData.apiLogMode) {
                        cc.log("使用缓存数据\n", response);
                    }
                    response.isResponseCache = true
                    responeSuccessCallback && responeSuccessCallback(response)
                    if (requestData.useCacheCallbackBreakRequest) {
                        return
                    }
                    if (!requestData.useCacheCallbackTwice) {
                        responeSuccessCallback = null
                    }
                }
            }
            if (requestData.isApiRequest) {
                requestData.baseUrl = AppData.httpApiMobileUrl + requestData.baseUrl
            }
            if (!requestData.params.hasOwnProperty("gameId")) {
                requestData.params["gameId"] = AppData.gameName
            }
            requestData.params["token"] = requestData.token ? requestData.token : ModelData.instance.userToken
            requestData.params["timestamp"] = this.get_now_timestamp()

            requestData.params["lang"] = AppData.apiLanguage
            requestData.params["os"] = GameUtil._systemOS
            requestData.params["sign"] = GameUtil.signature(requestData.params)
            requestData.url = GameUtil.formatParamsForHttp(requestData)
            if (AppData.apiLogMode) {
                cc.log("开始请求httpAPI：", requestData.url)
            }
            requestData.logRecord && LogManager.instance.log(`http get ${requestData.url}`, false)
        } else {
            requestData.url = requestData.baseUrl
        }

        requestData.timeOutRequestCount = 0
        if (requestData.timeOutRequestMax == null) {
            requestData.timeOutRequestMax = 6
        }
        this._http_get(requestData, responeSuccessCallback, requestErrorCallback)
    }

    private static _http_get(requestData: IHttpRequestData, responeSuccessCallback: (data: any) => void, requestErrorCallback?: (error: IHttpErrorData) => void) {
        try {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        if(requestData.loadTex){
                            responeSuccessCallback(xhr.response)
                            return
                        }
                        let responseText = xhr.responseText
                        if (requestData.encrypt && responseText.indexOf("{") != 0) {
                            let str = responseText.replace("\"", "").replace("\"", "");
                            let decoded = Utility.decryptAES(str, AppData.AESKey)
                            if (decoded != "") {
                                responseText = decoded
                            }
                        }
                        var response = JSON.parse(responseText);
                        if (!response) {
                            cc.error("http返回数据格式错误：", xhr.responseURL, responseText)
                            return
                        }
                        if (AppData.apiLogMode) {
                            cc.log("收到httpAPI回复\n", responseText);
                        }
                        if (requestData.useCache) {
                            LoaclStorage.setStorageString(requestData.cacheKey, responseText)
                        }
                        requestData.logRecord && LogManager.instance.log(`http get respone: ${requestData.url} ret: ${xhr.responseText}`, false)
                        responeSuccessCallback && responeSuccessCallback(response)
                    } else if (xhr.status == 500) {
                        if(requestData.loadTex){
                            return
                        }
                        let errorData : IHttpErrorData= {
                            error : xhr.responseText,
                        }
                        if (xhr.responseText && xhr.responseText != "") {
                            var responseData = Utility.jsonParse<IHttpError500Data>(xhr.responseText);
                            if (responseData) {
                                errorData.code = responseData.code
                                errorData.msg = responseData.msg
                                errorData.detail = responseData.detail
                                if (requestErrorCallback) {
                                    requestErrorCallback(errorData)
                                } else {
                                    if (!requestData.notShow500ErrorToast) {
                                        if (responseData.code == "B00011") {
                                            ModuleManager.instance.toastKey("server_error_code_B00011")
                                        } else {
                                            ModuleManager.instance.toast500error(responseData)
                                        }
                                        
                                        ModuleManager.instance.hideModule("NetPrompt");
                                    }
                                }
                                //无效的会话token参数、账号被封停，需要重新登录
                                if (responseData.code && (responseData.code == "B00020" || responseData.code == "P00011")) {
                                    ModuleManager.instance.goToLoginScene()
                                } 
                            } else {
                                requestErrorCallback && requestErrorCallback({error : xhr.responseText})
                            }
                        } else {
                            requestErrorCallback && requestErrorCallback({error : xhr.responseText})
                        }
                        LogManager.instance.log(`http get 500error: ${requestData.url} ret: ${xhr.responseText}`, true)
                    } else {
                        cc.warn("http request error:", xhr.statusText)
                    }
                }
            };
            //ontimeout 现在暂时只在web上生效，webchat需要使用onerror
            xhr.onerror = function (err: any) {
                //需要确认在超时的时候是否也会同时回调onreadystatechange
                cc.error("_http_get onerror", err, CC_PREVIEW ? requestData.url : "")
                if (err && typeof (err) == 'string' && err.indexOf('timeout') !== -1) {
                    if (requestData.timeOutRequestCount < requestData.timeOutRequestMax) {
                        cc.log("onerror 开始请求httpAPI：", requestData.url,requestData.timeOutRequestCount,requestData.timeOutRequestMax)
                        GameUtil._http_get(requestData, responeSuccessCallback, requestErrorCallback)
                    }
                    requestData.timeOutRequestCount += 1
                } else {
                    if (requestErrorCallback) {
                        requestErrorCallback({error : "Request Error"})
                    }
                }
            }
            xhr.ontimeout = function (err: any) {
                cc.log("ontimeout", requestData.url)
                if (!requestData.disableTimeOutRequest && requestData.timeOutRequestCount < requestData.timeOutRequestMax) {
                    let diffTime = new Date().getTime() - requestData.requestTime
                    if (diffTime < 3000) {
                        setTimeout(() => {
                            LogManager.instance.log(`timeout 延迟 请求httpAPI：${requestData.url} ${requestData.timeOutRequestCount} ${requestData.timeOutRequestMax}`)
                            GameUtil._http_get(requestData, responeSuccessCallback, requestErrorCallback)
                        }, 3000 - diffTime)
                    } else {
                        LogManager.instance.log(`timeout 请求httpAPI：${requestData.url} ${requestData.timeOutRequestCount} ${requestData.timeOutRequestMax}`)
                        GameUtil._http_get(requestData, responeSuccessCallback, requestErrorCallback)
                    }
                } else {
                    requestErrorCallback && requestErrorCallback({error : "Request Timeout"})
                }
                requestData.timeOutRequestCount += 1
            }
            requestData.requestTime = new Date().getTime()
            xhr.timeout = 10000
            xhr.open("GET", requestData.url, true);
            requestData.loadTex && (xhr.responseType = 'arraybuffer')
            xhr.send();
        } catch (error) {
            cc.error("_http_get error", error);
        }
    }

    private static _http_put(requestData: IHttpRequestData, header: any, body: Document | BodyInit | null, responeSuccessCallback: any, responeErrorCallback: any, isTextResponse?: boolean) {
        try {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        if (isTextResponse) {
                            responeSuccessCallback && responeSuccessCallback(xhr.responseText)
                            return
                        }
                        var response = JSON.parse(xhr.responseText);
                        if (!response) {
                            cc.error("http返回数据格式错误：", xhr.responseURL, xhr.responseText)
                            return
                        }
                        if (AppData.apiLogMode) {
                            cc.log("收到httpAPI回复\n", xhr.responseText);
                        }
                        if (requestData.useCache) {
                            MemoryStorage.setJson(requestData.cacheKey, response)
                        }
                        responeSuccessCallback && responeSuccessCallback(response)
                    } else {
                        cc.error('status:', xhr.status, xhr.responseText)
                        if (xhr.responseText && xhr.responseText != "") {
                            if (isTextResponse) {
                                responeErrorCallback(xhr.responseText)
                                return
                            }
                            var response = JSON.parse(xhr.responseText);
                            if (responeErrorCallback) {
                                responeErrorCallback(response)
                            } else {
                                ModuleManager.instance.toast500error(response)
                            }
                        } else {
                            if (responeErrorCallback) {
                                responeErrorCallback(null)
                            }
                        }
                        cc.warn("http request error:", xhr.statusText)
                    }

                }
            };
            //ontimeout 现在暂时只在web上生效，webchat需要使用onerror
            xhr.onerror = function (err: any) {
                //需要确认在超时的时候是否也会同时回调onreadystatechange
                cc.log(err)
                if (err && typeof (err) == 'string' && err.indexOf('timeout') !== -1) {
                    if (requestData.timeOutRequestCount < 6) {
                        GameUtil._http_put(requestData, header, body, responeSuccessCallback, responeErrorCallback, isTextResponse)
                    }
                    requestData.timeOutRequestCount += 1
                }
            }
            //z
            xhr.ontimeout = function (err: any) {
                cc.log("ontimeout")
                if (requestData.timeOutRequestCount < 6) {
                    GameUtil._http_put(requestData, header, body, responeSuccessCallback, responeErrorCallback, isTextResponse)
                }
                requestData.timeOutRequestCount += 1
            }
            xhr.timeout = 10000
            xhr.open("PUT", requestData.baseUrl, true);
            if (header) {
                for (const key in header) {
                    if (header.hasOwnProperty(key)) {
                        const value = header[key];
                        xhr.setRequestHeader(key, value)
                    }
                }
            }
            xhr.send(body);
        } catch (error) {
            cc.error("error", error);
        }
    }

    static http_put(requestData: IHttpRequestData, header: any, bytes: Uint8Array, responeSuccessCallback: any, responeErrorCallback: any) {
        this._http_put(requestData, header, bytes, responeSuccessCallback, responeErrorCallback, true)
    }

    static signature(params: object) {
        let sortedObjKeys = Object.keys(params).sort();
        let text = params["token"]
        for (let key of sortedObjKeys) {
            if (key != "token") {
                text += key + params[key]
            }
        }
        text += "LGCSBnMznC8IO5L1"
        return CryptoJS.MD5(text).toString(CryptoJS.enc.Hex)
    }

    static loadTexture(url: string, callback) {
        let requestData: IHttpRequestData = {
            url: url,
            baseUrl: url,
            timeOutRequestCount: 0,
            timeOutRequestMax: 6,
            loadTex: true,
        }
        GameUtil._http_get(requestData, function(response){
            var blob = new Uint8Array(response);
            var img = new Image();
            let strinsdf = util.base64.encode(blob, 0, blob.length)
            var base = "data:image/png;base64," + strinsdf;
            img.src = base;
            img.onload = function () {
                var texture = new cc.Texture2D();
                texture.initWithElement(img);
                texture.handleLoadedTexture();
                callback(null, texture, blob)
            }
        }, function(err){
            cc.warn("load texture error:", url, err)
        })
        // url = encodeURI(url)
        // var xhr = new XMLHttpRequest();
        // xhr.onreadystatechange = function () {
        //     if (xhr.readyState == 4) {
        //         if (xhr.status == 200) {
        //             var blob = new Uint8Array(this.response);
        //             var img = new Image();
        //             let strinsdf = util.base64.encode(blob, 0, blob.length)
        //             var base = "data:image/png;base64," + strinsdf;
        //             img.src = base;
        //             img.onload = function () {
        //                 var texture = new cc.Texture2D();
        //                 texture.initWithElement(img);
        //                 texture.handleLoadedTexture();
        //                 callback(null, texture, blob)
        //             }
        //         } else {
        //             callback(xhr.statusText, null)
        //             cc.warn("load texture error:", xhr.statusText)
        //         }
        //     }
        // };
        // xhr.open("get", url);
        // xhr.responseType = 'arraybuffer';
        // xhr.send(null);

    }

    static formatParamsForHttp(data: IHttpRequestData): string {
        let url: string = ""
        let baseUrl = data.baseUrl
        let index: number = 0
        for (const key in data.params) {
            if ( data.params[key] == null || data.params[key] == undefined) {
                cc.warn("key not in params:", key, data.params)      
                continue;          
            }
            if (index == 0) {
                url = baseUrl + key + "=" + this.encodeURL(data.params[key].toString())
            } else {
                url = url + "&" + key + "=" + this.encodeURL(data.params[key].toString())
            }
            index += 1
        }
        return url
    }
    //seach是指url从'?'后面的部分，包含?
    static getQueryString(seach: string, keyName: string) {
        //匹配指定name的QueryString
        var reg = new RegExp('(^|&)' + keyName + '=([^&]*)(&|$)', 'i');
        var r = seach.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]); //用于解码"="后的值,即$2
        }
        return null;
    };



    static encodeURL(s: string): string {
        return encodeURIComponent(s)
    }

    static string2point(s): string {
        let l = s.charCodeAt(0)
        let e = l.toString(16)
        return ("%" + e)
    }

    static get_tokenAndTimestamp(userId: number) {
        let x: [string, number]
        let timestamp = this.get_now_timestamp()
        let token = this.get_md5(timestamp, userId, AppData.SALT_A, AppData.SALT_B)
        x = [token, timestamp]
        return x
    }

    static get_now_timestamp() {
        let d = new Date()
        let timestamp = Date.parse(d.toString());
        return timestamp / 1000
    }

    static get_md5(timestamp: number | Long, userId: number | Long, salt_a: string, salt_b: string) {
        let s1 = CryptoJS.MD5(salt_a + userId.toString()).toString(CryptoJS.enc.Hex)
        let s2 = s1.replace("-", "").toLowerCase()
        let s3 = CryptoJS.MD5((timestamp.toString() + s2 + salt_b)).toString(CryptoJS.enc.Hex)
        let s4 = s3.replace("-", "").toLowerCase()
        return s4
    }

    //获取字符串的字节长度
    static stringBytesLength(str: string) {
        let length: number = 0
        for (let i = 0; i < str.length; i++) {
            let iCode = str.charCodeAt(i);
            if ((iCode >= 0 && iCode <= 255) || (iCode >= 0xff61 && iCode <= 0xff9f)) {
                length += 1;
            } else {
                length += 2;
            }
        }
        return length
    }
    //字符串转utf8字节
    static str2UTF8Byte(str) {
        var bytes = new Array();
        var len, c;
        len = str.length;
        for (var i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if (c >= 0x010000 && c <= 0x10FFFF) {
                bytes.push(((c >> 18) & 0x07) | 0xF0);
                bytes.push(((c >> 12) & 0x3F) | 0x80);
                bytes.push(((c >> 6) & 0x3F) | 0x80);
                bytes.push((c & 0x3F) | 0x80);
            } else if (c >= 0x000800 && c <= 0x00FFFF) {
                bytes.push(((c >> 12) & 0x0F) | 0xE0);
                bytes.push(((c >> 6) & 0x3F) | 0x80);
                bytes.push((c & 0x3F) | 0x80);
            } else if (c >= 0x000080 && c <= 0x0007FF) {
                bytes.push(((c >> 6) & 0x1F) | 0xC0);
                bytes.push((c & 0x3F) | 0x80);
            } else {
                bytes.push(c & 0xFF);
            }
        }
        return bytes;
    }

    //static _ResCaches = {}

    static loadRes(url: string, completeCallback: (error: Error, resource: any) => void, type?: typeof cc.Asset, connect?: number): void {
        // let res = GameUtil._ResCaches[url]
        // if (res) {
        //     completeCallback(null, res)
        //     return
        // }

        if (!connect) {
            connect = 1
        }

        cc.loader.loadRes(url, type, function (error: Error, resource: any) {
            //cc.loader.loadRes(url, type, function (error: Error, resource: any) {
            if (error) {
                connect += 1
                if (connect < 10) {
                    GameUtil.loadRes(url, completeCallback, type, connect)
                    cc.warn("loadRes失败，重试：", url, error)
                } else {
                    completeCallback(error, resource)
                }
            } else {
                //GameUtil._ResCaches[url] = resource
                completeCallback(error, resource)
            }
        })
    }

    static releaseRes(url: string, use?: string) {

        resLoader.releaseRes(url, use);
    }

    static loadResArray(url: string[], completeCallback: (error: Error, resource: any[]) => void, connect?: number): void {
        if (!connect) {
            connect = 1
        }

        cc.loader.loadResArray(url, function (error: Error, resource: any[]) {
            if (error) {
                connect += 1
                if (connect < 10) {
                    GameUtil.loadResArray(url, completeCallback, connect)
                    cc.warn("loadRes失败，重试：", url, error)
                } else {
                    completeCallback(error, resource)
                }
            } else {
                // GameUtil._ResCaches[url] = resource
                completeCallback(error, resource)
            }
        })
    }

    /** 
   * @param str：需要截取的字符串 
   * @param len: 需要截取的长度 默认五个汉字的 
   */
    static cutStr(str, len = 10) {
        return Utility.strClamp(str, len)
    }

    // 货币格式 fixedNumb:保留小数，当为-1时，会依情况显示0，1，2位小数 isInt 处理小数为0的情况
    static currencyFormatting(money: number, fixedNumb: number = 2, isInt: boolean = false, needFormatZero: boolean = false): string {
        if (money == null) {
            return '';
        }

        if (Math.abs(money) <= 0.001) {
            if(needFormatZero){
                if(money == 0){
                    return this.stringNumFormat(money, fixedNumb)
                }
            }
            return '0';
        }
        let unitIndex = 0;
        let i = money;
        for (; Math.abs(i) >= 1e3;) {
            i /= 1e3;
            unitIndex++;
        }
        if (unitIndex < GameUtil.unit.length) {
            let num = (i > 0? Math.floor(i * 1000 / 10): Math.ceil(i * 1000 / 10)) / 100;//这样做为了处理一个误差77.1*100
            if (isInt) {
                let arr = (num.toString()).split("."); //是否有小数
                fixedNumb = arr.length >= 2 ? fixedNumb : 0
            }
            else if (fixedNumb == -1) {
                let x = String(num).indexOf('.') + 1; //是否有小数
                let y = String(num).length - x; //小数的位数
                fixedNumb = y > 2 ? 2 : y
            }
            return this.stringNumFormat(num, fixedNumb) + GameUtil.unit[unitIndex];
        } else {//超过T
            return this.stringNumFormat(money / 1e12, fixedNumb) + 'T';
        }
    }

    static stringNumFormat(num: number, fixedNum: number){
        let str = num.toFixed(fixedNum)
        if(fixedNum > 0){
            let re = new RegExp(`\\.[0]{${fixedNum}}`, 'g')
            str = str.replace(re, '')

        }        
        return str
    }

    // 货币格式
    static currencyFormat(money: number): string {
        return GameUtil.currencyFormatting(money)
    }

    static captureScreen(node, fn) {
        node.active = true
        let width = Math.floor(node.width);
        let height = Math.floor(node.height);
        let fileName = "result_share.jpg";
        let camera = node.addComponent(cc.Camera);
        camera.zoomRatio = 2.2
        //camera.enabled = false
        camera.cullingMask = 0xffffffff;
        let texture = new cc.RenderTexture();
        texture.initWithSize(width, height);
        camera.targetTexture = texture;


        camera.render(node);
        let data = texture.readPixels();
        // 接下来就可以对这些数据进行操作了
        if (CC_JSB) {
            let fullPath = jsb.fileUtils.getWritablePath() + fileName;
            if (cc.sys.os == cc.sys.OS_ANDROID){
                let osJson = AppController.instance.deviceInfo()
                let osStr = osJson.os.replace("Android ",'')
                let osStrlist = osStr.split(".")
                if (Number(osStrlist[0]) >= 10){
                    fullPath = "/data/data/" + AppData.bundleId + "/cache/" + fileName;
                }
            }
            if (jsb.fileUtils.isFileExist(fullPath)) {
                jsb.fileUtils.removeFile(fullPath);
            }
            //以下代码将截图后默认倒置的图片回正
            let picData = new Uint8Array(width * height * 4);
            let rowBytes = width * 4;
            for (let row = 0; row < height; row++) {
                let srow = height - 1 - row;
                let start = Math.floor(srow * width * 4);
                let reStart = row * width * 4;
                // save the piexls data
                for (let i = 0; i < rowBytes; i++) {
                    picData[reStart + i] = data[start + i];
                }
            }
            //保存图片
            jsb.saveImageData(picData, width, height, fullPath);
            cc.log("截图成功，图片保存在 ====>", fullPath);
            AppController.instance.saveImageToGallery(fullPath, "ImageSave", fileName)
            if (fn) fn(fullPath);
        }
        else {
            // 网页截图
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            let rowBytes = width * 4;
            for (let row = 0; row < height; row++) {
                let srow = height - 1 - row;
                let imageData = ctx.createImageData(width, 1);
                let start = srow * width * 4;
                for (let i = 0; i < rowBytes; i++) {
                    imageData.data[i] = data[start + i];
                }

                ctx.putImageData(imageData, 0, row);
            }

            let dataURL = canvas.toDataURL();
            let img = document.createElement("img");
            img.src = dataURL;
            cc.log("截图成功，图片保存在 ====>");
            AppController.instance.saveFile(dataURL,"ShareImage")
        }

        node.parent.removeChild(camera);
        node.active = false
    }



    /**
   * [获取URL中的参数名及参数值的集合]
   * @param {[string]} urlStr [当该参数不为空的时候，则解析该url中的参数集合]
   * @return {[string]}       [参数集合]
   */
    static GetUrlParameter(urlStr) {
        if (typeof urlStr == "undefined") {
            var url = decodeURI(location.search); //获取url中"?"符后的字符串
        } else {
            var url = "?" + urlStr.split("?")[1];
        }
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    }
}
